// Rutgers University-New Brunswick's majors (#2652, round 2). Read on
// 2026-10-01 from Rutgers' official 2026-2027 New Brunswick Undergraduate
// Catalog, Major Programs of Study (newbrunswick-26-27-undergrad.catalogs.
// rutgers.edu/home/undergradednb/majorprgs). That page "summarizes the major
// programs available at one or more of the schools" in one list with no
// degrees and no schools, so this file has one group and degree is null
// throughout; the catalog says to "consult the individual schools' sections
// for a list of majors offered at each school". Names are the catalog's own,
// in its order. One formatting fix: the list prints "Environmental Studies
// 381" (381 is its subject code), shown here as "Environmental Studies".
// Kept exactly as printed and flagged for the lead: "Anthropology,
// Revolutionary" (very likely the Evolutionary Anthropology major).
const majors = {
    "slug": "rutgers-university-new-brunswick",
    "read": "2026-10-01",
    "intro": "Every major program in the official 2026-2027 New Brunswick Undergraduate Catalog's list of Major Programs of Study. The catalog gives one list for all ten New Brunswick schools, without degrees or schools; each school's section of the catalog says which majors it offers. Minors and certificates are left out.",
    "groups": [
        {
            "name": "Major programs of study",
            "source": {
                "label": "Rutgers New Brunswick Undergraduate Catalog 2026-2027, Major Programs of Study",
                "url": "https://newbrunswick-26-27-undergrad.catalogs.rutgers.edu/home/undergradednb/majorprgs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Actuarial Mathematics",
                    "degree": null
                },
                {
                    "name": "Aerospace Engineering",
                    "degree": null
                },
                {
                    "name": "African, Middle Eastern, and South Asian Languages and Literatures",
                    "degree": null
                },
                {
                    "name": "Africana Studies",
                    "degree": null
                },
                {
                    "name": "Agriculture and Food Systems",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Animal Science",
                    "degree": null
                },
                {
                    "name": "Anthropology, Cultural",
                    "degree": null
                },
                {
                    "name": "Anthropology, Revolutionary",
                    "degree": null
                },
                {
                    "name": "Applied Sciences in Engineering",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Astrophysics",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Sciences",
                    "degree": null
                },
                {
                    "name": "Biomathematics",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Biotechnology",
                    "degree": null
                },
                {
                    "name": "Business Analytics",
                    "degree": null
                },
                {
                    "name": "Cell Biology and Neuroscience",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "Cinema Studies",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Cognitive Science",
                    "degree": null
                },
                {
                    "name": "Communication",
                    "degree": null
                },
                {
                    "name": "Comparative Literature",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Criminal Justice",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Design",
                    "degree": null
                },
                {
                    "name": "Digital Filmmaking",
                    "degree": null
                },
                {
                    "name": "Ecology, Evolution, and Natural Resources",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Entomology",
                    "degree": null
                },
                {
                    "name": "Environmental and Business Economics",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Environmental Planning",
                    "degree": null
                },
                {
                    "name": "Environmental Policy, Institutions, and Behavior",
                    "degree": null
                },
                {
                    "name": "Environmental Sciences",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "European Studies",
                    "degree": null
                },
                {
                    "name": "Exercise Science",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Food Science",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Genetics",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Geological Sciences",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "Global Humanities",
                    "degree": null
                },
                {
                    "name": "Health Administration",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History/French",
                    "degree": null
                },
                {
                    "name": "History/Political Science",
                    "degree": null
                },
                {
                    "name": "Human Resource Management",
                    "degree": null
                },
                {
                    "name": "Industrial Engineering",
                    "degree": null
                },
                {
                    "name": "Information Technology and Informatics",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Journalism and Media Studies",
                    "degree": null
                },
                {
                    "name": "Korean",
                    "degree": null
                },
                {
                    "name": "Labor and Employment Relations",
                    "degree": null
                },
                {
                    "name": "Labor Studies and Employment Relations",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                },
                {
                    "name": "Latin American Studies",
                    "degree": null
                },
                {
                    "name": "Latino and Caribbean Studies",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Management and Global Business",
                    "degree": null
                },
                {
                    "name": "Management and Work",
                    "degree": null
                },
                {
                    "name": "Marine Sciences",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Medieval Studies",
                    "degree": null
                },
                {
                    "name": "Meteorology",
                    "degree": null
                },
                {
                    "name": "Microbiology",
                    "degree": null
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": null
                },
                {
                    "name": "Molecular Biology and Biochemistry",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Nursing",
                    "degree": null
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": null
                },
                {
                    "name": "Pharmacy",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Planning and Public Policy",
                    "degree": null
                },
                {
                    "name": "Plant Biology",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Portuguese",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Public Health",
                    "degree": null
                },
                {
                    "name": "Public Policy",
                    "degree": null
                },
                {
                    "name": "Religion",
                    "degree": null
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Social Work",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Sport Management",
                    "degree": null
                },
                {
                    "name": "Statistics and Biostatistics",
                    "degree": null
                },
                {
                    "name": "Statistics/Mathematics",
                    "degree": null
                },
                {
                    "name": "Supply Chain Management",
                    "degree": null
                },
                {
                    "name": "Theater Arts",
                    "degree": null
                },
                {
                    "name": "Urban Planning and Design",
                    "degree": null
                },
                {
                    "name": "Visual Arts",
                    "degree": null
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
